import { render, staticRenderFns } from "./UploadArt.vue?vue&type=template&id=424f1d1a&scoped=true&"
import script from "./UploadArt.vue?vue&type=script&lang=ts&"
export * from "./UploadArt.vue?vue&type=script&lang=ts&"
import style0 from "./UploadArt.vue?vue&type=style&index=0&id=424f1d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f1d1a",
  null
  
)

export default component.exports